import { RequestAssistance } from "./request-assistance";

export default function StorylineMenu(props: any) {
    return <>
        <RequestAssistance />
    </>;
}